export default "__VITE_ASSET__CjHe97v7__"